export default "__VITE_ASSET__Yf38y7uQ__"